import { PROPERTY_STRATEGIES_NAME, PROPERTY_TYPES } from '@constants';
const DAYS_IN_MILLISECONDS = 1_000 * 60 * 60 * 24;
const NUMBER_OF_BRICKS_TO_HAVE_LAST_BRICKS = 1000;
const NUMBER_OF_DAYS_FOR_A_NEW_PROPERTY = 30;
class CrowdfundingPropertyDetail {
    id;
    address;
    backyardSize;
    bricksAvailable;
    bricksSold;
    capRate;
    commercialValue;
    createdAt;
    launchDate;
    crowdfundingPeriods;
    deliveryEndingDate;
    deliveryStartingDate;
    description;
    developer;
    estimatedCapitalGain;
    estimatedLeasingPerBrick;
    estimatedAnnualProfit;
    guaranteedRent;
    hasTraderBricks;
    highlights;
    investmentStrategy;
    isActive;
    landSize;
    maximumBricksToBuy;
    minimumBricksToBuy;
    name;
    numberOfBathrooms;
    numberOfBricks;
    numberOfUnits;
    operatorId;
    parkingLotSpaces;
    petitionerId;
    photos;
    presalePrice;
    reservedBricks;
    retailPrice;
    revolvingFundContributionPerBrick;
    riskLevel;
    status;
    targetAmount;
    thumbnailURL;
    totalEstimatedLeasing;
    type;
    vestedAmount;
    videoURL;
    yearOfConstruction;
    yearsToSale;
    constructor(data) {
        this.id = data.id;
        this.address = data.address;
        this.backyardSize = data.backyardSize;
        this.bricksAvailable = data.bricksAvailable;
        this.bricksSold = data.bricksSold;
        this.capRate = data.capRate;
        this.commercialValue = data.commercialValue;
        this.capRate = data.capRate;
        this.createdAt = data.createdAt;
        this.launchDate = data.launchDate ? new Date(data.launchDate) : null;
        this.crowdfundingPeriods = data.crowdfundingPeriods;
        this.deliveryEndingDate = data.deliveryEndingDate;
        this.deliveryStartingDate = data.deliveryStartingDate;
        this.description = data.description;
        this.developer = data.developer;
        this.estimatedCapitalGain = data.estimatedCapitalGain;
        this.estimatedLeasingPerBrick = data.estimatedLeasingPerBrick;
        this.estimatedAnnualProfit = data.estimatedAnnualProfit;
        this.guaranteedRent = data.guaranteedRent;
        this.hasTraderBricks = data.hasTraderBricks;
        this.highlights = data.highlights;
        this.investmentStrategy = data.investmentStrategy;
        this.isActive = data.isActive;
        this.landSize = data.landSize;
        this.maximumBricksToBuy = data.maximumBricksToBuy;
        this.minimumBricksToBuy = data.minimumBricksToBuy;
        this.name = data.name;
        this.numberOfBathrooms = data.numberOfBathrooms;
        this.numberOfBricks = data.numberOfBricks;
        this.numberOfUnits = data.numberOfUnits;
        this.operatorId = data.operatorId;
        this.parkingLotSpaces = data.parkingLotSpaces;
        this.petitionerId = data.petitionerId;
        this.photos = data.photos;
        this.presalePrice = data.presalePrice;
        this.reservedBricks = data.reservedBricks;
        this.retailPrice = data.retailPrice;
        this.revolvingFundContributionPerBrick = data.revolvingFundContributionPerBrick;
        this.riskLevel = data.riskLevel;
        this.status = data.status;
        this.targetAmount = data.targetAmount;
        this.thumbnailURL = data.thumbnailURL;
        this.totalEstimatedLeasing = data.totalEstimatedLeasing;
        this.type = data.type;
        this.vestedAmount = data.vestedAmount;
        this.videoURL = data.videoURL;
        this.yearOfConstruction = data.yearOfConstruction;
        this.yearsToSale = data.yearsToSale;
    }
    hasLastBricks() {
        return Boolean(this.bricksAvailable > 0 && this.bricksAvailable < NUMBER_OF_BRICKS_TO_HAVE_LAST_BRICKS);
    }
    getPropertyTypeName() {
        return PROPERTY_TYPES[this.type];
    }
    getStrategyName() {
        return PROPERTY_STRATEGIES_NAME[this.investmentStrategy];
    }
    hasAvailableBricks() {
        return Boolean(this.bricksAvailable > 0);
    }
    isCapitalGainPool() {
        return Boolean(this.investmentStrategy === 'CAPITAL_GAIN_POOL');
    }
    isBoomerang() {
        return Boolean(this.investmentStrategy === 'BOOMERANG');
    }
    isPatrimonial() {
        return Boolean(this.investmentStrategy === 'PATRIMONIAL');
    }
    isAmericanProperty() {
        return Boolean(this.address.country.code === 'US');
    }
    isSold() {
        return Boolean(this.bricksAvailable < this.minimumBricksToBuy || this.bricksAvailable === 0);
    }
    isNew() {
        const differenceInDays = this.getDiferenceBetweenDatesInDays(new Date(this.createdAt));
        return Boolean(differenceInDays <= NUMBER_OF_DAYS_FOR_A_NEW_PROPERTY);
    }
    getDiferenceBetweenDatesInDays = (creationDate) => {
        const currentDate = new Date();
        const differenceInMilliseconds = Number(currentDate) - Number(creationDate);
        return Math.trunc(differenceInMilliseconds / DAYS_IN_MILLISECONDS);
    };
}
export default CrowdfundingPropertyDetail;
